
if (!window.MOL_UNSUPPORTED_BROWSER) {
    require('./main-vue-app');
}